

export const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

export const maxContent = (text?: string, length: number = 25) => {
    if (text! && text.length > length) {
        return `${text.substring(0, length)}...`
    } else {
        return text
    }
}


export const kettleModeToText = (mode: number, connection: boolean, setPointTemperature: number): string => {
    if (!connection) {
        return "Оффлайн"
    }
    switch (mode) {
        case 0: return "Онлайн"
        case 1: return "Кипячение"
        case 3: return `Разогрев до ${setPointTemperature}\u00A0°C`
        case 4: return `Поддержка ${setPointTemperature}\u00A0°C`
        case 5: return "IQ кипячение"
    }
    return "Оффлайн"
}
const DIGITS_REGEXP = /^\d*$/;
export const isDigit = (text: string): boolean => {
    if (DIGITS_REGEXP.test(text)) {
        return true
    }
    return false
}

export const replaceUnderline = (text: string): string => {
    return text.replaceAll("_", " ")
}

